import { RootState } from "../../../../../ReduxToolkit/Store";

export const teamMembersLeaveApprovedLoader = [
  (state: RootState) => state.teamMembersLeaveList.loading,
  (state: RootState) => state.teamMembersLeaveApproved.loading,
  (state: RootState) => state.teamMembersLeaveBulkApprovedRequest.loading,
];
